import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledModal = styled(Modal, {
  '&.abyss-modal-content-container': {
    background: 'transparent !important',
  },
});

const AlertContainer = styled('div', {
  marginBottom: '10px',
});

const StyledModalSection = styled(Modal.Section, {
  padding: 0,
});

export const AlertBanner = ({ alerts, onClose }) => {
  const handleCloseOverlay = () => {
    if (onClose) {
      alerts.forEach((alert, index) => onClose(0));
    }
  };
  return (
    <React.Fragment>
      <StyledModal
        isOpen={onClose && alerts.length > 0}
        onClose={handleCloseOverlay}
        hideClose
      >
        <StyledModalSection>
          <For each="alert" of={alerts} index="index">
            <AlertContainer>
              <Alert
                key={alert.title}
                title={alert.title}
                variant={alert.variant}
                errorCode={alert.code}
                onClose={onClose && (() => onClose(index))}
              >
                {alert.message}
              </Alert>
            </AlertContainer>
          </For>
        </StyledModalSection>
      </StyledModal>
    </React.Fragment>
  );
};

AlertBanner.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      variant: PropTypes.string,
      type: PropTypes.string,
      code: PropTypes.string,
      message: PropTypes.node,
    })
  ).isRequired,
  styles: PropTypes.shape({}),
  onClose: PropTypes.func,
};

AlertBanner.defaultProps = {
  styles: null,
  onClose: null,
};
